import React from "react";
import "./Video.css";

const Video = () => {
  return (
    <div className="parent-container">
      <div class="video-container">
        <iframe
          className="video-supercamp"
          width="1200"
          height="675"
          src="https://www.youtube.com/embed/gAdLrN511Ck?si=wAPeX_Bmo9620Rki"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
};

export default Video;
